import { Fragment, useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../../Context/GlobalContext";
import { CheckoutButton } from "./CheckoutButton";
import { CourierPickupAlert } from "./CourierPickup/CourierPickup";
import { StandardDelivery } from "./Delivery/Delivery";
import { MethodSelection } from "./MethodSelection";
import { ShopCounterPickup } from "./ShopCounterPickup/ShopCounterPickup";
import { isValidArray } from "../../../Layout/Common/common";
import { Link, useNavigate } from "react-router-dom";
import { NOTEMESSAGE, SHIPPING_METHOD } from "../../../constants";
import { NoteMessageContainer } from "../../../Layout/Common/alert/noteMessageContainer";
import { NoShippingAvailable } from "./NoShippingAvailable";

export const MainContent = () => {
  const [pickupOnlyProduct, setPickupOnlyProduct] = useState(null);
  const [IsInternationalUser, setIsInternationalUser] = useState(null);
  const globalcontext = useContext(GlobalContext);
  const { deliveryMethod, shippingMode, setDeliveryMethod } = useContext(GlobalContext);
  const [isValid, setIsValid] = useState(false);
  useEffect(() => {
    setPickupOnlyProduct(globalcontext.pickupOnlyProduct);
    setIsInternationalUser(globalcontext.IsInterNational);
  }, [globalcontext.pickupOnlyProduct, globalcontext.IsInterNational]);

  useEffect(() => {
    if (deliveryMethod != null) {
      if (String(deliveryMethod).includes(SHIPPING_METHOD[1])) {
        if (shippingMode != null) setIsValid(true);
        else setIsValid(false);
      } else {
        setIsValid(true);
      }
    } else {
      setDeliveryMethod(SHIPPING_METHOD[1]);
    }
  }, [deliveryMethod, shippingMode]);

  return (
    <div className="col-lg-12">
      {IsInternationalUser == true && pickupOnlyProduct && isValidArray(pickupOnlyProduct) ? (
        <NoShippingAvailable />
      ) : (
        <div className="delivery-method">
          <h3>Delivery Method</h3>
          <MethodSelection pickupOnlyProduct={pickupOnlyProduct} />
          <div className="tab-content" id="pills-tabContent">
            {IsInternationalUser == true ? (
              <StandardDelivery />
            ) : pickupOnlyProduct && isValidArray(pickupOnlyProduct) ? (
              <ShopCounterPickup isPickupOnly={true} />
            ) : (
              <Fragment>
                <StandardDelivery />
                <ShopCounterPickup />
                <CourierPickupAlert />
              </Fragment>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
